import Cookies from 'js-cookie';

import api from 'plugin/api';
import { TOKEN, ROUTER_PATH } from 'types/const';
import { RETURN_YN } from 'types/type';
import decode from 'utils/json/decode';

/**
 * 로그인 정보 설정
 * @param {Object} value 값
 */
function setLoginInform(value) {
  Cookies.set(
    'login',
    JSON.stringify({
      ...getLoginInform(),
      ...value
    }),
    { expires: 1 }
  );

  Cookies.set('haccpYn', JSON.stringify({ haccpYn: value.haccpYn }));

  if (value[TOKEN]) {
    api.defaults.headers.common[TOKEN] = value[TOKEN];
  }
}

/**
 * 로그인 정보 초기화
 */
function resetLoginInform() {
  Cookies.remove('login');
  Cookies.remove('haccpYn');
  delete api.defaults.headers.common[TOKEN];
}

/**
 * 로그인 정보 반환
 * @return {Object} 로그인 정보
 */
function getLoginInform() {
  return decode(Cookies.get('login'), true) ?? {};
}

/**
 * 홈 URL 반환
 * @todo 리팩토링 필요
 * @return {string} 홈 URL
 */
function getHomeURL() {
  const { haccpYn, authList } = getLoginInform();

  // haccp 로그인 여부에 따른 모니터링 이천,군산구분
  const factory = authList?.find(e => e.readYn === 'Y');
  const { pltCd } = factory || {};

  let factoryRoute = ROUTER_PATH.sfsh.monitoring.icheon.view;

  if (pltCd === 'A120') {
    factoryRoute = ROUTER_PATH.sfsh.monitoring.gunsan.view;
  }

  return haccpYn === RETURN_YN.Y
    ? factoryRoute
    : ROUTER_PATH.sfms.dashboard.main;
}

export { setLoginInform, resetLoginInform, getLoginInform, getHomeURL };
